import Cookies from "js-cookie"
import { getAsanaProjects, getTasks } from "./api"


const compareCookies = (newCookie, cname) => {
    let oldCookies = Cookies.get(cname)

    if (oldCookies !== JSON.stringify(newCookie)) {
        Cookies.set(cname, JSON.stringify(newCookie))
        window.location.reload()
    }
}

export const updateProjects = async () => {
    const projectsArray = []
    let newProjectsCookies = await getAsanaProjects()
    newProjectsCookies = newProjectsCookies.data
    newProjectsCookies.map((item) => {
        projectsArray.push({
            name: item.name, id: item.id
        })
    })
    compareCookies(projectsArray, 'projects')
}
export const updateTasks = async (id) => {
    let tasksArray = []
    let newTasksCookies = await getTasks(id)
    newTasksCookies = newTasksCookies.data
    newTasksCookies.map((task) => {
        tasksArray.push({
            name: task.name,
            completed_at: task.completed_at,
            due_on: task.due_on,
            completed: task.completed,
        })
    })
    compareCookies(tasksArray, id)
}

export const getProjectsCookies = async () => {
    let tryCookie = Cookies.get('projects')
    if (tryCookie) {
        updateProjects()
        return JSON.parse(tryCookie)
    } else {
        let projectsArray = []
        let newProjectsCookies = await getAsanaProjects()
        newProjectsCookies = newProjectsCookies.data

        newProjectsCookies.map((item) => {
            projectsArray.push({
                name: item.name, id: item.id
            })
        })
        Cookies.set('projects', JSON.stringify(projectsArray), { expires: 1 })
        return projectsArray
    }
}
export const getTasksCookies = async (id) => {
    let tryCookie = Cookies.get(id)
    if (tryCookie) {
        updateTasks(id)
        return JSON.parse(tryCookie)
    } else {
        let tasksArray = []
        let newTasksCookies = await getTasks(id)
        newTasksCookies = newTasksCookies.data
        newTasksCookies.map((task) => {
            tasksArray.push({
                name: task.name,
                completed_at: task.completed_at,
                due_on: task.due_on,
                completed: task.completed,
            })
        })
        Cookies.set(id, JSON.stringify(tasksArray), { expires: 1 })
        return tasksArray
    }
}